<template>
  <div>
    <div v-if="form">
      <div class="is-flex is-align-items-flex-end is-justify-content-space-between">
        <div>
          <p><b>statuses ({{ statuses.length }} items)</b></p>
          <select v-model="form.data.offer.fields.status.value" @change="onStatusChange" dir="ltr" style="min-width: 200px;">
            <option value="">בחר סטטוס...</option>
            <option v-if="isSystemStrong" value="system_strong" disabled>system_strong</option>
            <option
              :key="status.value"
              v-for="status in statuses"
              :value="status.value"
              >{{ status.text }}</option
            >
          </select>
        </div>
        <div class="horizontal_space"></div>
        <div dir="ltr" class="is-flex is-flex-wrap-wrap">
          <a @click="onClickApplicantStrong" style="background-color: purple; color: white;" class="button margin-bottom">awaiting_applicant_strong</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='company_process'" style="background-color: green;" class="button is-info margin-bottom">company_process</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='interview'" style="background-color: green;" class="button is-info margin-bottom">interview</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='admin_rejected'" class="button is-danger margin-bottom">admin_rejected</a>
          <div class="horizontal_space"></div>
          <a @click="onClickRejectWithExplanation" class="button is-danger margin-bottom">דחה והסבר</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='company_familiar'" class="button is-danger margin-bottom">company_familiar</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='applicant_rejected'" class="button is-danger margin-bottom">applicant_rejected</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='company_rejected'" class="button is-danger margin-bottom">company_rejected</a>
          <div class="horizontal_space"></div>
          <a @click="form.data.offer.fields.status.value='expired_before_sent'" style="background-color: purple; color: white;" class="button margin-bottom">expired_before_sent</a>
        </div>
      </div>
      <div v-if="show_explanation_textarea" class="field mt-3">
        <label class="label">הסבר לדחייה</label>
        <div class="control">
          <textarea
            v-model="rejection_explanation"
            class="textarea"
            placeholder="הסבר לדחייה..."
            rows="3"
            style="direction: rtl;"
          ></textarea>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div v-if="offer_data">
        <div class="is-flex is-align-items-end" style="gap: 20px;">
          <div>
            <div class="is-flex is-flex-direction-column">
              <button @click="setAutomaticMessage('noAnswer')" class="button is-warning mb-2 is-fullwidth">לא ענה לטלפון</button>
              <button @click="setAutomaticMessage('notRelevantBecause')" class="button is-warning mb-2 is-fullwidth">לא רלוונטי</button>
              <button v-if="$settings.get({ path: 'operation_name' }) == 'Rebase'" @click="setAutomaticMessage('notRelevantConstruction')" class="button is-warning mb-2 is-fullwidth">לא רלוונטי לבניה</button>
              <button @click="setAutomaticMessage('notInterested')" class="button is-warning mb-2 is-fullwidth">לא מעוניין</button>
              <div v-if="$route.name == 'admin-offers'" class="mt-3">
                <a @click="vested" class="button is-info is-fullwidth">Vested</a>
              </div>
            </div>
          </div>
          <div style="flex: 1;">
            <message-form ref="message_form" :payload="{ resource_data: offer_data }">
            </message-form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'
import MessageForm from '@/components/MessageForm'
export default {
  name: 'offer-status-form',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      is_loading: false,
      offers_helper: new OffersHelper(),
      offer_data: undefined,
      form: undefined,
      rejection_explanation: '',
      show_explanation_textarea: false
    }
  },
  computed: {
    ...mapGetters('offerStatuses', ['getStatusList', 'getRedList', 'getGreenList']),
    statuses () {
      return this.getStatusList || []
    },
    // system_strong is blacklisted from manual selection, but an offer that is already in it
    // must still show its current status (read-only) instead of an empty select.
    isSystemStrong () {
      return !!(this.offer_data && this.offer_data.status && this.offer_data.status.name === 'system_strong')
    },
    defaultMessage () {
      return this.payload.defaultMessage || ''
    },
    shouldCreateMassageCompleteStat () {
      return this.payload.shouldCreateMassageCompleteStat || false
    },
    applicantId () {
      return this.payload.applicantId || null
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // Always try to fetch statuses to make sure we have them
      this.$store.dispatch('offerStatuses/fetchOfferStatuses').then(() => {
        this.loadOffer()
      }).catch((error) => {
        console.error('Failed to fetch offer statuses:', error)
        this.loadOffer() // Try to load offer anyway
      })
    },
    loadOffer () {
      this.$network_utils.getResourceOffer({ offer_id: this.payload.offer_data.id }).then(response => {
        this.offer_data = response

        // If we have a default message, prepend it to the existing message
        if (this.defaultMessage && response.message) {
          this.offer_data = {
            ...response,
            message: this.defaultMessage + response.message
          }
        } else if (this.defaultMessage) {
          this.offer_data = {
            ...response,
            message: this.defaultMessage
          }
        }

        this.setForm(response)
      }).catch(error => {
        console.error('❌ Error loading offer:', error)
      })
    },
    vested () {
      this.create({ designator: 'vested-confirmation-modal', component_name: 'VestedConfirmationForm', data: this.offer_data, modal_title: 'Vested' })
    },
    setForm (form_data) {
      this.form = new this.$form({
        offer: {
          fields: {
            status: {
              value: form_data.status.name,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/offers/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    async getBusinessDate (data) {
      return this.$moment(await this.$network_utils.getNextBusinessDate(data))
    },
    setAutomaticMessage (messageType) {
      const messages = {
        noAnswer: 'המועמד לא ענה לטלפון',
        notRelevantBecause: 'המועמד לא רלוונטי מכיוון ש...',
        notRelevantConstruction: 'המועמד לא רלוונטי לתחום הבניה',
        notInterested: 'מועמד לא מעוניין במשרה'
      }

      if (this.$refs.message_form && messages[messageType]) {
        const currentMessage = this.$refs.message_form.message || ''
        const separator = currentMessage.trim() ? '\n' : ''
        this.$refs.message_form.message = currentMessage + separator + messages[messageType]
      }
    },
    onStatusChange () {
      if (this.form.data.offer.fields.status.value !== 'admin_rejected') {
        this.show_explanation_textarea = false
      }
    },
    onClickRejectWithExplanation () {
      this.form.data.offer.fields.status.value = 'admin_rejected'
      this.show_explanation_textarea = true
      this.rejection_explanation = ''
    },
    async onClickApplicantStrong () {
      const responce = await this.$network_utils.getResourceOffers({
        resource_type: 'Applicant',
        company_id: this.offer_data.position.company.resource_id,
        resource_id: this.offer_data.applicant.resource_id,
        statuses: `${this.getGreenList.map(s => s.name).join(',')},${this.getRedList.map(s => s.name).join(',')},company_never_replied`
      })
      const companyWarning = this.offer_data.position.company.priority_warning
      if (responce.length != 0 || companyWarning) {
        this.create({
          designator: 'offer-warnings-modal',
          component_name: 'AlertWarningContent',
          modal_title: 'Offers warnings',
          props: {
            offer: this.offer_data,
            closeModal: this.removeModalById,
            submitModal: (d) => {
              this.form.data.offer.fields.status.value = 'awaiting_applicant_strong'
              this.removeModalById(d)
            }
          }
        })
      } else {
        this.form.data.offer.fields.status.value = 'awaiting_applicant_strong'
      }
    },
    submit () {
      if (this.show_explanation_textarea && !this.rejection_explanation.trim()) {
        this.$utils.emit('show_toast', {
          text: 'אנא מלא הסבר לדחייה',
          type: 'warning'
        })
        return
      }
      this.is_loading = true
      const new_status = this.form.data.offer.fields.status.value
      this.$network_utils
        .getResourceAlerts({
          resource_type: 'Offer',
          resource_id: this.offer_data.id,
          statuses: 'active,in_progress',
          designator: 'strong_offers,send_cv'
        })
        .then((alerts) => {
          if (!alerts.length) {
            if (
              this.offer_data.status.color == 'red' &&
              this.getGreenList.map((s) => s.name).includes(new_status)
            ) {
              this.$network_utils.postAlert({
                designator: 'send_cv',
                resource_type: 'Offer',
                resource_id: this.offer_data.id,
                minimum_permission: 1,
                maximum_permission: 6
              })
            }
            if (new_status == 'awaiting_applicant_strong') {
              this.$network_utils.postAlert({
                designator: 'strong_offers',
                resource_type: 'Offer',
                resource_id: this.offer_data.id,
                timing: this.$moment().add(8, 'hours'),
                maximum_permission: 9
              })
            }
          }
        })
      if (['company_process', 'interview'].includes(new_status)) {
        this.$network_utils.getStats({
          designator: 'accurate_send',
          page: 1,
          per: 1,
          current_resource_type: 'Offer',
          current_resource_id: this.offer_data.id,
          owner: this.offer_data.owner
        }).then(stat => {
          if (!stat.length) {
            this.$network_utils.postStat({
              title: 'Accurate Send',
              designator: 'accurate_send',
              status: 'active',
              owner: this.offer_data.owner,
              resource_type: 'Offer',
              resource_id: this.offer_data.id
            })
          }
        })
      }
      const messageFooter = '<messsage-meta><message-date>' + new Date() + '</message-date><owner>' + this.$utils.getOwner().name + '</owner></messsage-meta>'
      const fullMessage = this.$refs.message_form.getFullMessage()

      this.offers_helper.changeOfferStatus({
        offer: this.offer_data,
        new_data: Object.assign({
          status: this.form.data.offer.fields.status.value,
          message: `${fullMessage}\n\n${messageFooter}`
        },
        this.form.data.offer.fields.status.value == 'awaiting_applicant_strong' ? { owner: this.$utils.getOwner().name } : null,
        this.show_explanation_textarea && this.rejection_explanation.trim() ? { rejection_explanation: this.rejection_explanation.trim() } : null)
      }).then(async (response) => {
        if (this.shouldCreateMassageCompleteStat && this.applicantId) {
          const messageWithoutDefault = fullMessage.replace(this.defaultMessage, '').trim()

          if (messageWithoutDefault.length > 0) {
            try {
              await this.$network_utils.postStat({
                resource_type: 'Applicant',
                resource_id: this.applicantId,
                designator: 'massage_complete',
                content: fullMessage,
                owner: this.$utils.getOwner().name,
                title: 'Massage Complete',
                status: 'active'
              })
              console.log('[OfferStatusForm] Created massage_complete stat')
            } catch (error) {
              console.error('[OfferStatusForm] Error creating massage_complete stat:', error)
            }
          } else {
            console.warn('[OfferStatusForm] User did not complete the default message, stat not created')
            this.$utils.emit('show_toast', {
              text: 'אנא השלם את המשפט לפני השמירה',
              type: 'warning'
            })
          }
        }

        this.is_loading = false
        this.remove(this.payload)
        this.$utils.emit('show_toast', { text: 'סטטוס שונה בהצלחה!' })
      }).catch((error) => {
        console.error('❌ changeOfferStatus error:', error)
        this.is_loading = false
      })
    },
    ...mapMutations('modals', ['removeModalById', 'remove', 'create'])
  },
  components: {
    MessageForm
  }
}
</script>

<style scoped>
.margin-bottom {
  margin-bottom: 10px;
}
</style>
